import { List, Stack, Text, Title } from '@mantine/core';

export const SingleSignOn = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Single Sign-On (SSO)</Title>

            <Text>Some organizations use Single Sign-On to authenticate their users. If your account is configured for SSO, you will be automatically redirected to your company's identity provider to sign in.</Text>

            <Title order={4} td="underline">How It Works</Title>

            <List type="ordered" spacing="sm">
                <List.Item>Select your account on the sign-in screen</List.Item>
                <List.Item>The system detects that your account uses SSO</List.Item>
                <List.Item>You are redirected to your company's login page</List.Item>
                <List.Item>After successful authentication, you are returned to Panasonic Cloud</List.Item>
            </List>

            <Title order={4} td="underline">SSO and Password</Title>

            <Text>If your account has both SSO and password sign-in enabled, you will be asked to choose your preferred method. You can select "Use SSO" or "Use username and password".</Text>

            <Title order={4} td="underline">Common Questions</Title>

            <List spacing="sm">
                <List.Item><strong>I was redirected to a different login page</strong> — This is normal. Your organization manages authentication through their own identity provider.</List.Item>
                <List.Item><strong>SSO login failed</strong> — Contact your organization's IT administrator. The issue is likely with your company's identity provider, not Panasonic Cloud.</List.Item>
            </List>
        </Stack>
    );
};
